import { FormControl, Input } from 'native-base';
import React from 'react';
import Functions from '../../utils/Functions';
/**
 * @param label - Input field label
 * @param value - Input value
 * @param errors - Error object with isEmpty field for error handling
 * @param handleChange - Method to handle the changing input
 * @returns Number input field with validation
 */
export const InputNumber = _ref => {
  let {
    label,
    value,
    errors,
    handleChange
  } = _ref;
  return /*#__PURE__*/React.createElement(FormControl, {
    isInvalid: errors === null || errors === void 0 ? void 0 : errors.isEmpty,
    justifyContent: 'space-between'
  }, /*#__PURE__*/React.createElement(FormControl.Label, null, label), /*#__PURE__*/React.createElement(Input, {
    width: 282,
    size: "2xl",
    keyboardType: "numeric",
    value: `${Functions.toLocalString(value)}`,
    onChangeText: handleChange,
    placeholder: "$0",
    isFocused: true,
    borderRadius: 2,
    borderColor: 'grey.900',
    bgColor: "white.700"
  }));
};
//# sourceMappingURL=index.js.map